// extracted by mini-css-extract-plugin
export default {"dropZone":"ImageDropzone_dropZone__mgZhL","label":"ImageDropzone_label__AT-To","error":"ImageDropzone_error__WL2qA"};